















































































import { Component, Watch } from "vue-property-decorator";
import ChatListComponent from "./components/chatLists.component.vue";
import ChatMenuComponent from "./components/chatMenu.component.vue";
import ChatContentComponent from "./components/chatContent.component.vue";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import PinnedMessagesComponent from "@/app/components/modals/pinnedMessages/pinnedMessages.component.vue";
import PinnedInChatComponent from "./components/pinnedInChat.component.vue";
import NewChatComponent from "./components/newChat.component.vue";
@Component({
  name: "chat-component",
  components: {
    PinnedMessagesComponent,
    PinnedInChatComponent,
    ChatListComponent,
    ChatMenuComponent,
    ChatContentComponent,
    NewChatComponent,
  },
})
export default class ChatComponent extends mixins(NotificationEvent) {
  openPinned = false;
  openChatList = false;
  openNewChat = false;
  showList = true;
  CHAT_TYPE = CHAT_TYPE;
  MEETING_TYPE = MEETING_TYPE;
  isTeams = false;
  created(): void {
    /* this.$store.dispatch(
      "ChatStore/setMinimizeChatAction",
      !this.$store?.getters["UserStore/getConfig"].chat.openRoomChatByDefault
    ); */
    setTimeout(() => {
      this.showOrNotChat();
    }, 300);

    const chatType = this.$store.getters["ChatStore/getChatType"];
    if (chatType == "") {
      this.openChatList = true;
    }
    // window.addEventListener("resize", this.setContentHeight);
  }
  mounted(): void {
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.isTeams = space?.superSpace?.isTeams;
  }
  get minimizeChat(): boolean {
    return this.$store.getters["ChatStore/getMinimizeChat"];
  }
  set minimizeChat(e: boolean) {
    this.$store.dispatch("ChatStore/setMinimizeChatAction", e);
  }
  get roomId(): string | null {
    return CHAT_TYPE.ROOM
      ? this.$store.getters["MeetingStore/getRoomId"]
      : null;
  }
  get chatType(): string {
    return this.$store.getters["ChatStore/getChatType"];
  }
  get pinnedMessagesLength(): number {
    return this.$store.getters["ChatStore/getPinnedMessagesLength"];
  }
  get unSeeMessage() {
    return this.$store.getters["ChatStore/getUnSeenMessage"];
  }
  get poll() {
    return this.$store.getters["PollStore/getPoll"];
  }
  getBadgeCount(): number {
    let badgeCount = 0;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.unSeeMessage.forEach((element) => {
      let data = JSON.parse(element?.payload?.Metadata);
      if (data && space.superSpace.id == data.superSpaceId) badgeCount++;
    });
    return badgeCount;
  }
  destroyed(): void {
    this.showList = false;
    setTimeout(() => {
      this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
    }, 20);

    //  window.removeEventListener("resize", this.setContentHeight);
  }

  async closeChat(): Promise<void> {
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    await this.$store.dispatch("SidebarStore/setOpenChatAction", false);
    if (
      meetingType !== MEETING_TYPE.ONE_TO_ONE &&
      meetingType !== MEETING_TYPE.SPEED_NETWORKING
    )
      await this.$store.dispatch("ChatStore/setUserChatAction", null);
    await this.$store.dispatch("ChatStore/setMessagesAction", []);
    await this.$store.dispatch(
      "ChatStore/setChatTypeAction",
      CHAT_TYPE.ONE_TO_ONE
    );

    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip[0]) tooltip[0].remove();
  }
  onOpenNewChat(e) {
    this.openNewChat = e;
    this.openChatList = false;
  }
  onOpenListChat(e) {
    this.openNewChat = false;
    this.openChatList = e;
  }
  openUserChat() {
    this.openNewChat = false;
    this.openChatList = false;
  }

  @Watch("minimizeChat")
  showOrNotChat() {
    const e = this.minimizeChat;
    const chatContainer = document.getElementById("chat-container");
    const chatActions = document.getElementById("chat-actions");
    const searchContainer = document.getElementById("search-container");
    const chatContent = document.getElementById("chat-content");
    const inputText = document.getElementById("input-text");
    if (!e) {
      if (chatActions) chatActions.style.display = "flex";
      if (searchContainer) searchContainer.style.display = "block";
      if (chatContent) chatContent.style.display = "block";
      if (inputText) inputText.style.display = "flex";
      if (chatContainer) chatContainer.style.height = "75%";
      switch (this.chatType) {
        case CHAT_TYPE.ROOM: {
          this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
            id: null,
            type: CHAT_TYPE.ROOM,
          });
          break;
        }
        case CHAT_TYPE.SPACE: {
          this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
            type: CHAT_TYPE.SPACE,
          });
          break;
        }
        case CHAT_TYPE.ONE_TO_ONE: {
          const user = this.$store.getters["ChatStore/getUserChat"];
          if (user)
            this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
              id: user.id,
              type: CHAT_TYPE.ONE_TO_ONE,
            });
          break;
        }
      }
    } else {
      if (chatActions) chatActions.style.display = "none";
      if (searchContainer) searchContainer.style.display = "none";
      if (chatContent) chatContent.style.display = "none";
      if (inputText) inputText.style.display = "none";
      if (chatContainer) chatContainer.style.height = "55px";
    }
  }
  setMinimizeChat(minimizeChat: boolean) {
    window.event.stopPropagation();
    this.minimizeChat = minimizeChat;
  }
}
